import React from 'react';

import BaseFilter from './BaseFilter';
import { getRespondentsScreening } from '../../../actions/asyncActions';
import withFilterForm from '../../hocs/withFilterForm';

export default withFilterForm(() =>
    <BaseFilter
        action={getRespondentsScreening}
        searchFieldName='text'
        searchFieldPlaceholder='Поиск'
        span={12} />
);
